<template>
  <div>
    <Track-Common
      :indent="indent"
      :gpsTrackingEnabled="gpsTrackingEnabled"
      :isSimTrackingAllowed="isSimTrackingAllowed"
      :simTrackingEnabled="simTrackingEnabled"
      :yetToTruckIn="yetToTruckIn"
      :hasDriverAccepted="hasDriverAccepted"
      :appTrackingEnabled="appTrackingEnabled"
      :hyperTrackingEnabled="hyperTrackingEnabled"
      :yetToDispatch="yetToDispatch"
      :isOrderLoading="isOrderLoading"
      :isShipper=false
      :isLoading="isLoading"
      :isMapLoading="isMapLoading"
      :showMap="showMap"
      :operator="operator"
      :consentStatus="consentStatus"
      :premiumSimTrackingEnabled="isTripIdAvailable"
      @getconsent="getconsent"
      :mapConfig="mapConfig"
      :environmentVariables="environmentVariables"
      @loadMap="loadMap" />
  </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { mapGetters } from 'vuex';
import { TripErrors, LocationTracker } from 'pando-constants';
import Track from '@common/components/track';

export default {
  props: {
    indent: {
      type: Object,
      default: () => {},
    },
    gpsTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    isSimTrackingAllowed: {
      type: Boolean,
      default: false,
    },
    simTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    yetToTruckIn: {
      type: Boolean,
      default: false,
    },
    hasDriverAccepted: {
      type: Boolean,
      default: false,
    },
    appTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    hyperTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    mapConfig: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    Vue.use(VueGoogleMaps, {
      load: {
        key: this.environmentVariables.gm_key,
        libraries: 'places',
        installComponents: true,
      },
    });
  },
  data() {
    return {
      operator: '',
      isLoading: false,
      showMap: false,
      consentStatus: '',
      isMapLoading: false,
      isOrderLoading: false,
    };
  },
  components: {
    'Track-Common': Track,
  },
  computed: {
    ...mapGetters({
      environmentVariables: 'app/environmentVariables',
    }),
    yetToDispatch() {
      return this.indent.sources.every(source => source.dispatched_at === null);
    },
    isTripIdAvailable() {
      return !!(this.indent && this.indent.flow.sim_tracking &&
        this.indent.flow.sim_tracking.is_enabled && this.indent.flow.sim_tracking.track_trip_id);
    },
  },
  methods: {
    async getLocation() {
      try {
        this.isMapLoading = true;
        const result =
          await this.$store.dispatch('indents/location', { orderNo: this.indent.order_no });
        this.data = result;
        const mapData = Object.assign({}, result, {
          mapSettings: this.environmentVariables && this.environmentVariables.map_settings,
        });
        this.$session.set('mapData', mapData);
        this.isMapLoading = false;
      } catch (err) {
        this.$error({ message: this.$t('INDENT_LOAD_MAP_ERROR_MSG') });
      }
    },
    async getconsent(phone, tripId) {
      try {
        if (tripId) {
          this.isLoading = true;
          const errorMsg = this.indent.track_error;
          if (!errorMsg || errorMsg === TripErrors.LOCATION_NOT_AVAILABLE) {
            await this.getLocation(tripId);
            this.showMap = true;
          } else if (errorMsg === TripErrors.OPERATOR_NOT_SUPPORTED) {
            this.consentStatus = LocationTracker.INVALID_TRIP;
          } else if (errorMsg === TripErrors.CONSENT_NOT_RECEIVED) {
            this.consentStatus = LocationTracker.PENDING_TRIP;
          }
        } else {
          this.consentStatus = this.$t('INDENT_TRIP_ID_NOT_AVAILABLE');
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.$error({ message: this.$t('INDENT_LOAD_MAP_ERROR_MSG') });
      }
    },
    async loadMap(tripId) {
      try {
        if (tripId) {
          this.isLoading = true;
          await this.getLocation(tripId);
          this.showMap = true;
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.$errorMessage({ message: this.$t('INDENT_LOAD_MAP_FAILED') });
      }
    },
  },
};
</script>
